import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dogsData: [],
};

const dogSlice = createSlice({
  name: "dog/reducer",
  initialState,
  reducers: {
    setDogsAction: (state, action) => {
      state.dogsData = action.payload;
    },
  },
});

export const { setDogsAction } = dogSlice.actions;

export const dogReducer = dogSlice.reducer;
